<template>
<div class="cardContainer">
    <div class="card" v-on:click="openPresentation">
        <div class="top-half">
            <div class="presenter">
                <img v-if="presenterInfo" v-bind:src="presenterInfo.pictureURL" class="presenterPhoto" onerror='this.onerror = "null"; this.src = "/static/img/anonymous.svg"'>
                <img v-else-if="presenterProfiles" v-bind:src="presenterProfiles.profiles[0].pictureURL" class="presenterPhoto" onerror='this.onerror = "null"; this.src = "/static/img/anonymous.svg"'>
                <img v-else src="../assets/icons/anonymous.svg" class="presenterPhoto">
            </div>
            <div class="slidePreview">
                <img v-bind:src="presentation.previewUrl" class="slidePicture">
            </div>
        </div>
        <div class="bottom-half">
            <div class="title">{{this.presentation.title}}</div>
            <div v-if="presenterInfo" class="subtitle">{{presenterInfo.displayName}}</div>
            <div v-else-if="presenterProfiles" class="subtitle">{{presenterProfiles.profiles[0].displayName}}</div>
            <div v-else class="subtitle">{{$t('str.DialogLoop')}}</div>
        </div>
    </div>
</div>
</template>

<script>
// TODO: create method for img onerror instead of writing statements in callback
import {EventBus} from '../router/index';

export default
{
    props: {
        presentation: {}
    },

    computed: {
        presenterInfo() {
            return this.presentation && this.presentation.props ? this.presentation.props.PresenterInfo : undefined;
        },

        presenterProfiles() {
            return this.presentation && this.presentation.props ? this.presentation.props.PresenterProfiles : undefined;
        }
    },

    methods: {
        openPresentation() {
            EventBus.$emit('openPresentation', this.presentation);
        }
    }
};

</script>

<style lang="scss">

.cardContainer {

    
    float: left;
    box-sizing: border-box;
    margin: 5px;

    .card {
        width: 310px;
        height: 160px;
        background-color: #242424;
        font-family: 'Poppins', sans-serif;
        overflow: hidden;
        transition: box-shadow 0.4s ease, top 0.4s ease, width 0.4s ease, height 0.4s ease;
        box-shadow: none;
        cursor: pointer;

        .top-half {
            width: 100%;
            height: 65%;
            max-height: 65%;
            background-color: #242424;
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;

            .presenter {
                height: 100%;
                width: 35%;
                right: 0;
                background-color: #242424;
                float: left;

                .presenterPhoto {
                    height: 70px;
                    width: 70px;
                    border-radius: 50%;
                    position: relative;
                    transform: translate(23%, 30%);
                }
            }

            .slidePreview {
                height: 100%;

                .slidePicture {
                    height: 100%;
                    width: 65%;
                    border-style: none;
                    box-sizing: inherit;
                }
            }
        }

        .bottom-half {
            margin-top: 10px;
            width: 90%;
            margin-left: auto;
            margin-right: auto;
            text-align: center;
            font-family: 'Poppins', sans-serif;

            .title {
                font-size: 14px;
                font-weight: 400;
                color: #f1f2f2;
                margin-bottom: 2px;
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
                display: block;
            }

            .subtitle {
                font-size: 12px;
                color: #d4451d;
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                text-align: center;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// SessionCard.vue?ce35221c